// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login__login-btn[data-v-2c851492]{height:44px;font-size:16px;margin:30px 0 18px;text-transform:capitalize}.login__login-btn .loader[data-v-2c851492]{margin:0 4px 0 0;width:unset}.settings__actions--save[data-v-2c851492]{margin-top:30px;height:44px}.small-sub[data-v-2c851492]{margin-top:16px;font-size:14px!important;font-weight:400!important;color:#7c8b91!important}", ""]);
// Exports
module.exports = exports;
